import { isExternal, isBoe, isVa } from '@meego/utils/src/platform/environment';

const getSladarBid = () => {
  let slardarBid = 'meego_boe';
  if (isExternal && isBoe) {
    slardarBid = 'meego_external_boe';
  } else if (isBoe) {
    slardarBid = 'meego_boe';
  } else if (isVa && isExternal) {
    slardarBid = 'meego_intl';
  } else if (isExternal) {
    slardarBid = 'meego_external';
  } else {
    slardarBid = 'meego';
  }
  return slardarBid;
};

export const slardarBid = getSladarBid();
